import BillingsOrderCargoTaxiRecalculateResponse, {
  BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionBaseAmount,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionChargeHaltings,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionContractCorrectionPercentage,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountBeingLate,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountIncompatibleCar,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOptimization,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOther,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContribution,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType,
  BillingsOrderCargoTaxiRecalculateResponseDataBillingNode,
  BillingsOrderCargoTaxiRecalculateResponseDataCargoOrder,
  BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel,
  BillingsOrderCargoTaxiRecalculateResponseDataContractCargoCompany,
  BillingsOrderCargoTaxiRecalculateResponseDataContract,
  BillingsOrderCargoTaxiRecalculateResponseData,
} from "../../../../../api/raily/billings/order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";
import BillingsOrderCargoTaxiRecalculate, {
  BillingsOrderCargoTaxiRecalculateBillingContributionBaseAmount,
  BillingsOrderCargoTaxiRecalculateBillingContributionType,
  BillingsOrderCargoTaxiRecalculateBillingContributionChargeHaltings,
  BillingsOrderCargoTaxiRecalculateBillingContributionContractCorrectionPercentage,
  BillingsOrderCargoTaxiRecalculateBillingContributionDiscountBeingLate,
  BillingsOrderCargoTaxiRecalculateBillingContributionDiscountIncompatibleCar,
  BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOptimization,
  BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOther,
  BillingsOrderCargoTaxiRecalculateBillingContribution,
  BillingsOrderCargoTaxiRecalculateBillingNode,
  BillingsOrderCargoTaxiRecalculateCargoOrder,
  BillingsOrderCargoTaxiRecalculateContractCargoCompany,
  BillingsOrderCargoTaxiRecalculateContract,
} from "./billings-order-cargo-taxi-recalculate";

const createStatus = (
  status: BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus,
): BillingStatus => {
  switch (status) {
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus.REOPENED:
      return BillingStatus.REOPENED;
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
  }
};

const createContributionBaseAmount = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionBaseAmount,
): BillingsOrderCargoTaxiRecalculateBillingContributionBaseAmount => {
  return {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.BASE_AMOUNT,
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
  };
};

const createContributionChargeHaltings = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionChargeHaltings,
): BillingsOrderCargoTaxiRecalculateBillingContributionChargeHaltings => {
  return {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.CHARGE_HALTING,
    comment: contribution.comment,
    distance: contribution.distance,
    amount: contribution.amount,
  };
};

const createContributionContractCorrectionPercentage = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionContractCorrectionPercentage,
): BillingsOrderCargoTaxiRecalculateBillingContributionContractCorrectionPercentage => {
  return {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE,
    comment: contribution.comment,
    percentage: contribution.percentage,
    amount: contribution.amount,
  };
};

const createContributionDiscountBeingLate = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountBeingLate,
): BillingsOrderCargoTaxiRecalculateBillingContributionDiscountBeingLate => {
  return {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_BEING_LATE,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContributionDiscountIncompatibleCar = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountIncompatibleCar,
): BillingsOrderCargoTaxiRecalculateBillingContributionDiscountIncompatibleCar => {
  return {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContributionDiscountOptimization = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOptimization,
): BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOptimization => {
  return {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_OPTIMIZATION,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContributionDiscountOther = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOther,
): BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOther => {
  return {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_OTHER,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContribution = (
  contribution: BillingsOrderCargoTaxiRecalculateResponseDataBillingContribution,
): BillingsOrderCargoTaxiRecalculateBillingContribution | undefined => {
  switch (contribution.type) {
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.BASE_AMOUNT:
      return createContributionBaseAmount(contribution);
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.CHARGE_HALTING:
      return createContributionChargeHaltings(contribution);
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE:
      return createContributionContractCorrectionPercentage(contribution);
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_BEING_LATE:
      return createContributionDiscountBeingLate(contribution);
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR:
      return createContributionDiscountIncompatibleCar(contribution);
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_OPTIMIZATION:
      return createContributionDiscountOptimization(contribution);
    case BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_OTHER:
      return createContributionDiscountOther(contribution);
    default:
      return undefined;
  }
};

const createContributions = (
  contributions: BillingsOrderCargoTaxiRecalculateResponseDataBillingContribution[],
): BillingsOrderCargoTaxiRecalculateBillingContribution[] => {
  return contributions
    .map(createContribution)
    .filter(
      (contribution) => contribution,
    ) as BillingsOrderCargoTaxiRecalculateBillingContribution[];
};

const createNode = (
  node: BillingsOrderCargoTaxiRecalculateResponseDataBillingNode,
): BillingsOrderCargoTaxiRecalculateBillingNode => {
  return {
    allowCharge: node.allowCharge,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinated,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    lat: node.lat,
    lon: node.lon,
    nodeUuid: node.nodeId,
    plannedDistance: node.plannedDistance,
    uuid: node.id,
    checkoutDate: node.checkoutDate,
    checkoutEventUuid: node.checkoutEventId,
    orderUuid: node.orderId,
    plannedDate: node.plannedDate,
  };
};

const createNodes = (
  nodes: BillingsOrderCargoTaxiRecalculateResponseDataBillingNode[],
): BillingsOrderCargoTaxiRecalculateBillingNode[] => {
  return nodes.map(createNode);
};

const createCargoOrder = (
  cargoOrder: BillingsOrderCargoTaxiRecalculateResponseDataCargoOrder,
): BillingsOrderCargoTaxiRecalculateCargoOrder => {
  return {
    uuid: cargoOrder.id,
    humanId: cargoOrder.humanId,
  };
};

const createContractModel = (
  model: BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel,
): BillingModel => {
  switch (model) {
    case BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel.SABS:
      return BillingModel.SABS;
    case BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel.OTHER:
      return BillingModel.OTHER;
  }
};

const createContractCargoCompany = (
  cargoCompany: BillingsOrderCargoTaxiRecalculateResponseDataContractCargoCompany,
): BillingsOrderCargoTaxiRecalculateContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
    displayName: cargoCompany.displayName,
  };
};

const createContract = (
  contract: BillingsOrderCargoTaxiRecalculateResponseDataContract,
): BillingsOrderCargoTaxiRecalculateContract => {
  return {
    allowChargeDuringRide: contract.allowChargeDuringRide,
    allowChargeWhileApproaching: contract.allowChargeWhileApproaching,
    allowChargeWhileReturning: contract.allowChargeWhileReturning,
    discountLimit: contract.discountLimit,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: createContractModel(contract.model),
    cargoCompany: createContractCargoCompany(contract.cargoCompany),
  };
};

const createData = (
  data: BillingsOrderCargoTaxiRecalculateResponseData,
): BillingsOrderCargoTaxiRecalculate => {
  return {
    status: createStatus(data.status),
    allContributionsAmount: data.allContributionsAmount,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    amountForDistance: data.amountForDistance,
    baseAmountValue: data.baseAmountValue,
    billingContributions: createContributions(data.billingContributions),
    billingNodes: createNodes(data.billingNodes),
    contractCorrectionPercentage: data.contractCorrectionPercentage,
    date: data.date,
    distance: data.distance,
    passengers: data.passengers,
    sumOfDiscounts: data.sumOfDiscounts,
    cargoOrder: createCargoOrder(data.cargoOrder),
    contract: createContract(data.contract),
    planEntryUuid: data.planEntryId,
  };
};

const create = (
  response: BillingsOrderCargoTaxiRecalculateResponse,
): BillingsOrderCargoTaxiRecalculate => {
  return createData(response.data);
};

const billingsOrderCargoTaxiRecalculateFactory = { create };

export default billingsOrderCargoTaxiRecalculateFactory;
